import PropTypes from "prop-types";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { formatAmount, formatCount, formatPercent } from "../../utils/gerenciaModel";
export const MetricasResumen = ({ metricas, loading }) => {
  const cards = [
    {
      label: "Transacciones",
      value: metricas && formatCount(metricas.totalTransacciones),
      color: "#1a73e8",
      bg: "#edf4ff",
    },
    {
      label: "Exitosas",
      value: metricas && formatCount(metricas.transaccionesExitosas),
      color: "#24834b",
      bg: "#edf8f0",
    },
    {
      label: "Fallidas",
      value: metricas && formatCount(metricas.transaccionesFallidas),
      color: "#c43434",
      bg: "#fff0f0",
    },
    {
      label: "Efectividad",
      value: metricas && formatPercent(metricas.efectividadGlobal),
      color: "#a56306",
      bg: "#fff7e8",
    },
    {
      label: "Monto total",
      value: metricas && formatAmount(metricas.montoTotal),
      color: "#7054a6",
      bg: "#f4f0fc",
    },
  ];
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2,minmax(0,1fr))", md: "repeat(5,minmax(0,1fr))" },
        gap: 1.5,
      }}
    >
      {cards.map((card) => (
        <Paper
          key={card.label}
          elevation={0}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: card.bg,
            border: `1px solid ${card.color}33`,
            minWidth: 0,
          }}
        >
          <Typography variant="body2" sx={{ fontSize: ".8125rem", color: "#526179", mb: 1 }}>
            {card.label}
          </Typography>
          <Typography
            component="div"
            sx={{
              fontSize: { xs: "1.125rem", sm: "1.25rem" },
              fontWeight: 700,
              color: "#27374d",
              overflowWrap: "anywhere",
            }}
          >
            {loading && !metricas ? <Skeleton width="65%" /> : card.value ?? "—"}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
};
MetricasResumen.propTypes = { metricas: PropTypes.object, loading: PropTypes.bool };
